import { DEFAULT_FONT_FAMILY, type ITableLayerProps } from '@/version-types';
import { getCellStyle } from './cell-style';

export const getTableCellIdsOfLoadingFonts = (
    tableLayerData: ITableLayerProps,
    loadingFontFamilies: readonly string[],
) => {
    if (loadingFontFamilies.length === 0) return [];

    const loadingFontFamilySet = new Set(loadingFontFamilies);

    return tableLayerData.cells.flat().reduce<string[]>((cellIds, cell) => {
        if (!cell?.content) return cellIds;

        const style = getCellStyle(cell, tableLayerData);
        const fontFamily = style.fontFamily ?? DEFAULT_FONT_FAMILY().name;
        if (loadingFontFamilySet.has(fontFamily)) {
            cellIds.push(cell.__renderId);
        }

        return cellIds;
    }, []);
};
